import { createAuth } from 'vue-auth3'
import api from '../axios'
import authBearer from 'vue-auth3/drivers/auth/bearer-token'
import router from '../router'

export const auth = createAuth({
  fetchData: {
    url: '/auth/user-admin',
  },
  refreshToken: {
    url: '/auth/refresh',
    enabled: true,
  },
  logoutData: {
    url: '/auth/logout',
  },
  loginData: {
    url: '/auth/login',
    staySignedIn: true,
    fetchUser: false,
  },
  plugins: {
    router,
  },
  drivers: {
    http: {
      request: api,
    },
    auth: authBearer,
  },
  authRedirect: 'auth/login',
  forbiddenRedirect: '/404',
  notFoundRedirect: '/404',
  rolesKey: 'roles',
  tokenDefaultKey: 'auth_access_token',
  cookie: {
    expires: 86400,
  },
})
